import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/group-setup/settings.md?raw';

const GroupSetupSettings: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default GroupSetupSettings;
